<template>
    <div style="margin-top: 6px; text-align: center">
      <div>Skin / Seed</div>
      <div class="tannin-cell low">
        Low Skin<br />
        &lt; {{ levels[options.variety.value].skin[1] }}
      </div>
      <div class="tannin-cell med">
        Medium Skin<br />
        {{ levels[options.variety.value].skin[1] }} -
        {{ levels[options.variety.value].skin[2] }}
      </div>
      <div class="tannin-cell high spaced-right">
        High Skin<br />
        &gt; {{ levels[options.variety.value].skin[2] }}
      </div>
      <div class="tannin-cell low spaced-left">
        Low Seed<br />
        &lt; {{ levels[options.variety.value].seed[1] }}
      </div>
      <div class="tannin-cell med">
        Medium Seed<br />
        {{ levels[options.variety.value].seed[1] }} -
        {{ levels[options.variety.value].seed[2] }}
      </div>
      <div class="tannin-cell high">
        High Seed<br />
        &gt; {{ levels[options.variety.value].seed[2] }}
      </div>
    </div>
</template>
<script>
export default {
  name: 'TanninLevelSummary',
  props: ['levels', 'options'],
};
</script>
<style lang="scss" scoped>
  @import '../assets/_colors.scss';
  @import '../assets/_globals.scss';
  @import '../assets/_common.scss';

  .tannin-cell{
    text-align: center;
  }

  .spaced-right{
    margin-right: 7px;
  }

  .spaced-left{
    margin-left: 7px;
  }
</style>



// WEBPACK FOOTER //
// src/components/TanninLevelSummary.vue